import React, { Fragment, useEffect } from "react";
import Header from "../comp/Header";
import { Helmet } from "react-helmet";
import NewFooter from "../comp/NewFooter";

type ListBlock = { type: "listItem"; text: string; level: number; ordered: boolean; numId: string };
type TextLink = { text: string; href: string };

type PolicyBlock =
  | { type: "heading"; level: number; text: string; id: string }
  | { type: "paragraph"; text: string; bold?: boolean; links?: TextLink[] }
  | { type: "socialItem"; label: string; text: string }
  | ListBlock
  | { type: "table"; rows: string[][] };

const policyBlocks: PolicyBlock[] = [
  {
    "type": "heading",
    "level": 1,
    "text": "Privacy Policy",
    "id": "PrivacyPolicy"
  },
  {
    "type": "paragraph",
    "text": "Last Update: August 7, 2026"
  },
  {
    "type": "paragraph",
    "text": "ASD Dev Video Player for All Format is committed to protecting your privacy and being transparent about how your data is collected, used, and shared. Please read this policy carefully before using the app."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Overview of Privacy Policy",
    "id": "OverviewofPrivacyPolicy"
  },
  {
    "type": "listItem",
    "text": "Definitions",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Information We Collect",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Permissions We Use",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "How we use your Data",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Share, Transfer, and Public Disclosure of User’s Personal Information",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Storage and Protection of Users’ Personal Information",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Use of Cookies",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Data Protection Officer (DPO)",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Your Privacy Rights and Choices",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Users of California",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "EU Users",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Users of Brazil",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Users of Virginia",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "DMCA Copyright Policy",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Infringement policy",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "How to Report Infringement",
    "level": 1,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "In-app Purchases",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Liability Limitation",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Disclaimer of Warranty",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Copyright and Trademarks",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Push Notifications",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Retention of data",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Data Recovery Policy",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Security of data",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Our Policy On “DO NOT TRACK” Signals Under The California Online Protection Act (CALOPPA)",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Third-Party Services",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Disclaimer",
    "level": 1,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Analytics",
    "level": 2,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Advertising",
    "level": 2,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Behavioral Remarketing",
    "level": 2,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Payments",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Links to other sites",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Children’s Privacy",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Privacy Policy Changes",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "listItem",
    "text": "Contact Us",
    "level": 0,
    "ordered": true,
    "numId": "16"
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Definitions",
    "id": "Definitions"
  },
  {
    "type": "paragraph",
    "text": "We have added this part so that users can easily understand the basics of the privacy policy."
  },
  {
    "type": "table",
    "rows": [
      [
        "Service",
        "Service means games, mobile applications, other products (“Games”), and websites operated by ASD Dev Video Player for All Format (“we,” “our,” or “us”)."
      ],
      [
        "Personal Data",
        "Personal Data means data about a living individual who can be identified from that data (or from those and other information either in our possession or likely to come into our possession)"
      ],
      [
        "Usage Data",
        "Usage Data is data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit)."
      ],
      [
        "Cookies",
        "Cookies are small files stored on your device (computer or mobile device)."
      ],
      [
        "Data Controller",
        "Data Controller means the natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and how any personal information is, or is to be, processed. For this Privacy Policy, we are a Data Controller of your Personal Data."
      ],
      [
        "Data Processors (or Service Providers)",
        "Data Processor (or Service Provider) means any natural or legal person who processes the data on behalf of the Data Controller. We may use the services of various Service Providers to process your data more effectively."
      ],
      [
        "Data Subject (or User)",
        "Data Subject is any living individual who is using our Service and is the subject of Personal Data."
      ],
      [
        "Data Protection Officer(DPO)",
        "A DPO is a designated person who is in charge of managing an organization's or company's data protection policy and making sure that data protection rules and laws, like the General Data Protection Regulation (GDPR) in the European Union, are followed. The DPO plays a critical role in safeguarding individuals' rights to privacy by making sure that personal data is handled safely and in compliance with the law."
      ],
      [
        "Advertising ID",
        "AAID (Android) or IDFA (iOS) — a resettable device identifier used for advertising."
      ]
    ]
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Information We Collect",
    "id": "InformationWeCollect"
  },
  {
    "type": "paragraph",
    "text": "We collect limited information to provide and improve our services."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "1. Information Collected Automatically",
    "id": "1InformationCollectedAutomatically"
  },
  {
    "type": "paragraph",
    "text": "When you use the app, we may collect:"
  },
  {
    "type": "listItem",
    "text": "Device information (such as device model and operating system version)",
    "level": 0,
    "ordered": false,
    "numId": "15"
  },
  {
    "type": "listItem",
    "text": "App usage data (such as features used and session duration)",
    "level": 0,
    "ordered": false,
    "numId": "15"
  },
  {
    "type": "listItem",
    "text": "Crash logs and diagnostic information",
    "level": 0,
    "ordered": false,
    "numId": "15"
  },
  {
    "type": "listItem",
    "text": "Advertising identifiers (such as AAID/IDFA)",
    "level": 0,
    "ordered": false,
    "numId": "15"
  },
  {
    "type": "listItem",
    "text": "IP address (used for analytics, fraud prevention, and approximate location)",
    "level": 0,
    "ordered": false,
    "numId": "15"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "2. Information You Provide",
    "id": "2InformationYouProvide"
  },
  {
    "type": "paragraph",
    "text": "We may collect:"
  },
  {
    "type": "listItem",
    "text": "Email address (only if you contact us for support)",
    "level": 0,
    "ordered": false,
    "numId": "38"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "3. Information from Third-Party Services",
    "id": "3InformationfromThirdPartyServices"
  },
  {
    "type": "paragraph",
    "text": "We use third-party services for analytics, advertising, and app functionality. These services may collect:"
  },
  {
    "type": "listItem",
    "text": "Device identifiers",
    "level": 0,
    "ordered": false,
    "numId": "20"
  },
  {
    "type": "listItem",
    "text": "Advertising ID",
    "level": 0,
    "ordered": false,
    "numId": "20"
  },
  {
    "type": "listItem",
    "text": "App interaction and performance data",
    "level": 0,
    "ordered": false,
    "numId": "20"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "4. Data We Do NOT Collect",
    "id": "4DataWeDoNOTCollect"
  },
  {
    "type": "paragraph",
    "text": "We do not ask for or collect any Sensitive Personal Data or information such as passwords related to other services, financial information such as bank account or credit card, debit card, or other payment instrument details, physical, physiological, and mental health conditions, sexual orientation, medical records, and history, or biometric information."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Permissions We Use",
    "id": "PermissionsWeUse"
  },
  {
    "type": "paragraph",
    "text": "The different types of permissions we ask from users to offer the best of our products and services are-"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "1. Local Media Permission",
    "id": "1LocalMediaPermission"
  },
  {
    "type": "paragraph",
    "text": "This permission allows the app to access photos and media files on your device so you can select images for editing and collage creation. All media processing happens locally, and your files are not uploaded."
  },
  {
    "type": "paragraph",
    "text": "On devices running Android 13 and above, the app requests READ_MEDIA_IMAGES and READ_MEDIA_VIDEO permissions to access photos and videos you choose to edit or include in collages. On Android 14 and above, the app may use the READ_MEDIA_VISUAL_USER_SELECTED permission, which allows you to grant access only to specific images and videos you select, rather than your entire media library. These permissions are used solely within the app and no media files are uploaded to external servers."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "2. Network",
    "id": "2Network"
  },
  {
    "type": "paragraph",
    "text": "This permission allows the app to connect to the internet for advertising, analytics, and feature updates. All image editing and media processing are performed locally on your device."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "3. Location Information",
    "id": "3LocationInformation"
  },
  {
    "type": "paragraph",
    "text": "We do not collect or access your precise location. Approximate location may be inferred from your IP address by third-party services for analytics and advertising purposes."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "4. Usage and Tracking Data",
    "id": "4UsageandTrackingData"
  },
  {
    "type": "paragraph",
    "text": "This Usage Data may include information such as your computer’s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data. It may also include information such as the type of mobile device you use, your mobile device's unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers, usage patterns, and other diagnostic data. We collect non-personal tracking information to help us improve the App and provide better services."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "5. Consumer Support and Follow-up Services",
    "id": "5ConsumerSupportandFollowupServices"
  },
  {
    "type": "paragraph",
    "text": "When users send their feedback or error reports via email, we obtain your username, email address, and email content. This helps in communicating with you about any problems you face while using our product or service."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "6. Notification Permission",
    "id": "6NotificationPermission"
  },
  {
    "type": "paragraph",
    "text": "For devices with Android 13 and above, with your permission, we may send notifications to inform you of important events, messages, news, or updates. You can turn these notifications on or off at any time in your device settings. We do not use notifications for unsolicited advertising."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "7. Crash Logs & Diagnostics",
    "id": "7CrashLogsDiagnostics"
  },
  {
    "type": "paragraph",
    "text": "To improve stability and identify bugs, our app may collect anonymized crash logs and diagnostic reports. These logs do not include personal content (such as photos, videos, or private files) and are used solely for troubleshooting and performance optimization."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "8. Storage Permission",
    "id": "8StoragePermission"
  },
  {
    "type": "paragraph",
    "text": "The app requests access to your device’s storage in order to read, modify, or delete media files as per your actions inside the app."
  },
  {
    "type": "listItem",
    "text": "The app requests MANAGE_EXTERNAL_STORAGE only to let users play, organize, clean, and secure their media files.",
    "level": 0,
    "ordered": false,
    "numId": "24"
  },
  {
    "type": "listItem",
    "text": "All operations are performed locally on the device and no media files are uploaded or shared externally.",
    "level": 0,
    "ordered": false,
    "numId": "24"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "9. Biometric Authentication",
    "id": "9BiometricAuthentication"
  },
  {
    "type": "paragraph",
    "text": "Our app may use biometric authentication features available on your device (such as fingerprint or face recognition) to protect access to secure or private sections of the app, including your private vault, where applicable. We do not collect, store, or share your biometric data. This authentication is handled entirely by your device's operating system, and we only receive a confirmation of successful authentication to grant access."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "10. Wake Lock Permission",
    "id": "10WakeLockPermission"
  },
  {
    "type": "paragraph",
    "text": "Our app uses this to keep your device awake temporarily while performing essential tasks such as processing images, playing videos, or completing ongoing operations. This permission does not collect or share any personal data and is used solely to ensure smooth app functionality."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "11. Microphone and audio recording Permission",
    "id": "11MicrophoneandaudiorecordingPermission"
  },
  {
    "type": "paragraph",
    "text": "Our app may access your microphone to record audio or voice memos directly inside the app for conversion to MP3 format. We do not listen passively in the background, and no audio data is transmitted to external servers or shared with third parties. You can revoke microphone permission at any time in your device Settings."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "12. Screen Recording Permission",
    "id": "12ScreenRecordingPermission"
  },
  {
    "type": "paragraph",
    "text": "Our app can record your device screen to capture video content. Screen recording is initiated only when you explicitly start it using the in-app control, and Android will always display a visible notification while recording is active. The recording is processed locally on your device and saved as a media file for conversion. We do not transmit screen recordings to any server, and we do not capture content from other apps unless you deliberately start recording while those apps are open."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "13. Floating mini-player (display over other apps) Permission",
    "id": "13FloatingminiplayerdisplayoverotherappsPermission"
  },
  {
    "type": "paragraph",
    "text": "Our app can display a small floating playback control window over other apps on your screen. This lets you control audio playback — play, pause, and skip tracks — while using other applications. The floating player does not read, collect, or transmit any information from other apps that are visible on your screen. It is used exclusively for playback control. You can dismiss the player at any time, and you may revoke this permission in Settings."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "14. Background processing and battery usage Permission",
    "id": "14BackgroundprocessingandbatteryusagePermission"
  },
  {
    "type": "paragraph",
    "text": "Converting video files to MP3 can take several minutes, especially for long files. To ensure your conversions complete without being interrupted by Android’s battery management system, the app may request an exemption from battery optimisation while a conversion task is actively running. This exemption applies only during active conversion or download tasks — it is not used to run ongoing background processes or collect data when you are not using the app. You can re-enable battery optimisation for this app at any time in Settings → Battery → Battery optimisation."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "How we Use your Data",
    "id": "HowweUseyourData"
  },
  {
    "type": "paragraph",
    "text": "We use the collected data for various purposes:"
  },
  {
    "type": "listItem",
    "text": "To provide and maintain our Service",
    "level": 0,
    "ordered": false,
    "numId": "10"
  },
  {
    "type": "listItem",
    "text": "To notify you about changes to our Service",
    "level": 0,
    "ordered": false,
    "numId": "10"
  },
  {
    "type": "listItem",
    "text": "To allow you to participate in interactive features of our Service when you choose to do so",
    "level": 0,
    "ordered": false,
    "numId": "10"
  },
  {
    "type": "listItem",
    "text": "To provide customer support",
    "level": 0,
    "ordered": false,
    "numId": "10"
  },
  {
    "type": "listItem",
    "text": "To gather analysis or valuable information so that we can improve our Service",
    "level": 0,
    "ordered": false,
    "numId": "10"
  },
  {
    "type": "listItem",
    "text": "To monitor the usage of our Service",
    "level": 0,
    "ordered": false,
    "numId": "10"
  },
  {
    "type": "listItem",
    "text": "To detect, prevent, and address technical issues",
    "level": 0,
    "ordered": false,
    "numId": "10"
  },
  {
    "type": "listItem",
    "text": "To follow legal guidelines",
    "level": 0,
    "ordered": false,
    "numId": "10"
  },
  {
    "type": "listItem",
    "text": "To identify and resolve bugs by analyzing crash logs and diagnostic reports.",
    "level": 0,
    "ordered": false,
    "numId": "10"
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Share, Transfer and Public Disclosure of User’s Personal Information",
    "id": "ShareTransferandPublicDisclosureofUsersPersonalInformation"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "SHARE",
    "id": "SHARE"
  },
  {
    "type": "paragraph",
    "text": "Your privacy is our priority. We may share limited user data with trusted third-party service providers such as Google Firebase to facilitate analytics, app performance monitoring, and service improvement. These third parties process data on our behalf in accordance with their respective privacy policies."
  },
  {
    "type": "listItem",
    "text": "Obtained your permission:",
    "level": 0,
    "ordered": false,
    "numId": "64"
  },
  {
    "type": "listItem",
    "text": "When needed to comply with state agencies, authority, or administrative or legal instructions.",
    "level": 0,
    "ordered": false,
    "numId": "26"
  },
  {
    "type": "listItem",
    "text": "To meet the objectives stated in 'Collection and Use of Users’ Personal Information'.",
    "level": 0,
    "ordered": false,
    "numId": "26"
  },
  {
    "type": "listItem",
    "text": "Share with ad services and tech support partners.",
    "level": 0,
    "ordered": false,
    "numId": "26"
  },
  {
    "type": "paragraph",
    "text": "A list of available third-party SDKs for integration is mentioned below under the “Service Providers”."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "TRANSFER",
    "id": "TRANSFER"
  },
  {
    "type": "paragraph",
    "text": "We will not disclose your personal information to any company, organization, or individual, except as required by law, administrative enforcement, or regulatory authorities."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "PUBLIC DISCLOSURE",
    "id": "PUBLICDISCLOSURE"
  },
  {
    "type": "paragraph",
    "text": "As required by laws, regulations, or legal authorities, we may need to share your personal information with enforcement or regulatory bodies. Any disclosure will be limited to the specific information requested and will follow the prescribed legal procedures."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Storage and Protection of Users’ Personal Information",
    "id": "StorageandProtectionofUsersPersonalInformation"
  },
  {
    "type": "paragraph",
    "text": "Our app requires access to your device’s media storage to provide seamless functionality, such as browsing, playing, downloading, and managing your media files. This access is granted through the Media Storage Permission as per Google’s guidelines. By allowing this permission, our app can retrieve and display media files stored on your device, such as videos, music, and any format of media files to enhance your user experience. Rest assured, we only access the necessary media files for the app’s core functions, and we do not collect, store, share, or sell any personal information from your media library. Users retain full control over their files, and data is handled responsibly in compliance with Google's policies to ensure privacy and security.",
    "links": [
      {
        "text": "Media Storage Permission",
        "href": "https://developer.android.com/training/data-storage/shared/media"
      }
    ]
  },
  {
    "type": "paragraph",
    "text": "For AI-powered features, any processing of user images occurs either locally on your device or via encrypted channels. Processed images are not retained on our servers beyond the session. Crash logs and diagnostics are anonymized before storage, ensuring no personal data can be linked back to an individual."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "Local HTTP Server (NanoHTTPD)",
    "id": "LocalHTTPServer"
  },
  {
    "type": "paragraph",
    "text": "Our app uses NanoHTTPD, a lightweight open-source library, to create a local HTTP server environment on your device. This server operates entirely on your device (localhost) and is used solely for the offline gaming feature."
  },
  {
    "type": "listItem",
    "text": "The local server does not transmit any data to external servers or third parties.",
    "level": 0,
    "ordered": false,
    "numId": "34"
  },
  {
    "type": "listItem",
    "text": "It does not accept connections from other devices on your network.",
    "level": 0,
    "ordered": false,
    "numId": "34"
  },
  {
    "type": "listItem",
    "text": "It is only active when offline gaming is in use and does not run persistently in the background.",
    "level": 0,
    "ordered": false,
    "numId": "34"
  },
  {
    "type": "listItem",
    "text": "No personal data, media files, or user information is served through or exposed by this local server.",
    "level": 0,
    "ordered": false,
    "numId": "34"
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Use of Cookies",
    "id": "UseofCookies"
  },
  {
    "type": "paragraph",
    "text": "We value your privacy and treat data collected through cookies and similar technologies as non-personal information. A \"cookie\" is a small piece of data stored on your device by websites to help enhance your browsing experience. These cookies do not contain personal details such as your name, email address, or any other identifiable information. Instead, they are used to recognize your device and remember preferences or actions taken during your visit. You have the option to disable cookies at any time through your browser settings."
  },
  {
    "type": "paragraph",
    "text": "Examples of Cookies we use:"
  },
  {
    "type": "listItem",
    "text": "Session Cookies - We use Session Cookies to operate our Service.",
    "level": 0,
    "ordered": false,
    "numId": "7"
  },
  {
    "type": "listItem",
    "text": "Preference Cookies - We use Preference Cookies to remember your preferences and various settings.",
    "level": 0,
    "ordered": false,
    "numId": "7"
  },
  {
    "type": "listItem",
    "text": "Security Cookies - We use Security Cookies for security purposes.",
    "level": 0,
    "ordered": false,
    "numId": "7"
  },
  {
    "type": "listItem",
    "text": "Advertising Cookies - Advertising Cookies are used to serve you with advertisements that may be relevant to you and your interests.",
    "level": 0,
    "ordered": false,
    "numId": "7"
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Data Protection Officer (DPO)",
    "id": "DataProtectionOfficerDPO"
  },
  {
    "type": "paragraph",
    "text": "We have appointed a Data Protection Officer (DPO) to oversee our data protection strategy and ensure that our app complies with privacy regulations. The DPO is responsible for:"
  },
  {
    "type": "paragraph",
    "text": "Monitoring compliance with data protection laws."
  },
  {
    "type": "paragraph",
    "text": "Acting as a point of contact for data protection-related inquiries."
  },
  {
    "type": "paragraph",
    "text": "Assisting users in exercising their data protection rights."
  },
  {
    "type": "paragraph",
    "text": "If you have any questions about your privacy or would like to exercise any of your rights under applicable laws, please contact our DPO."
  },
  {
    "type": "paragraph",
    "text": "Contact Information for the DPO:"
  },
  {
    "type": "listItem",
    "text": "Email: feedback@rareprob.com",
    "level": 0,
    "ordered": false,
    "numId": "43"
  },
  {
    "type": "listItem",
    "text": "Contact No.: +91 8279323413",
    "level": 0,
    "ordered": false,
    "numId": "43"
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Your Privacy Rights and Choices",
    "id": "YourPrivacyRightsandChoices"
  },
  {
    "type": "paragraph",
    "text": "Depending on the laws in your jurisdiction, you may have several rights regarding your personal information. These rights could include:"
  },
  {
    "type": "listItem",
    "text": "Access to Information: You can request information about the data we have collected about you.",
    "level": 0,
    "ordered": false,
    "numId": "8"
  },
  {
    "type": "listItem",
    "text": "Manage Permissions: You may revoke any permissions you’ve previously granted, such as access to your camera or photo library.",
    "level": 0,
    "ordered": false,
    "numId": "8"
  },
  {
    "type": "listItem",
    "text": "Data Deletion: Request the deletion of your personal information.",
    "level": 0,
    "ordered": false,
    "numId": "8"
  },
  {
    "type": "listItem",
    "text": "Opt-Out: You can choose to opt out of receiving personalized advertisements.",
    "level": 0,
    "ordered": false,
    "numId": "8"
  },
  {
    "type": "listItem",
    "text": "You can opt out of third-party login and use email/password instead.",
    "level": 0,
    "ordered": false,
    "numId": "8"
  },
  {
    "type": "listItem",
    "text": "You may request access, correction, or deletion of your personal data.",
    "level": 0,
    "ordered": false,
    "numId": "8"
  },
  {
    "type": "listItem",
    "text": "You may disable account tracking or data collection for analytics in Settings.",
    "level": 0,
    "ordered": false,
    "numId": "8"
  },
  {
    "type": "paragraph",
    "text": "Opt-Out of Data Sharing and Targeted Advertising",
    "bold": true
  },
  {
    "type": "paragraph",
    "text": "We respect our users' privacy and provide them with control over how their data is used."
  },
  {
    "type": "listItem",
    "text": "We do not sell personal information of our users.",
    "level": 0,
    "ordered": false,
    "numId": "47"
  },
  {
    "type": "listItem",
    "text": "For general users, we do not use personal data for targeted or behavioral advertising unless explicitly stated.",
    "level": 0,
    "ordered": false,
    "numId": "47"
  },
  {
    "type": "paragraph",
    "text": "You have the right to opt out of the sharing of your data for advertising or analytics purposes."
  },
  {
    "type": "paragraph",
    "text": "You can exercise this right by:"
  },
  {
    "type": "listItem",
    "text": "Disabling Ad Personalization in your device settings",
    "level": 0,
    "ordered": false,
    "numId": "49"
  },
  {
    "type": "listItem",
    "text": "Resetting or limiting your Advertising ID (AAID/IDFA)",
    "level": 0,
    "ordered": false,
    "numId": "49"
  },
  {
    "type": "listItem",
    "text": "Contact us at feedback@rareprob.com with the subject: “Opt-Out Request”",
    "level": 0,
    "ordered": false,
    "numId": "49"
  },
  {
    "type": "paragraph",
    "text": "Once we receive your request, we will process it within a reasonable timeframe in accordance with applicable laws such as GDPR, CCPA, and other privacy regulations."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "Right to Lodge a Complaint",
    "id": "RighttoLodgeaComplaint"
  },
  {
    "type": "paragraph",
    "text": "You have the right to lodge a complaint with a competent supervisory authority if you believe that your data protection rights have been violated."
  },
  {
    "type": "paragraph",
    "text": "For users in the European Economic Area (EEA), you may contact your local data protection authority. A list of supervisory authorities is available through your country’s official data protection body."
  },
  {
    "type": "paragraph",
    "text": "For users in other regions, you may contact your relevant regulatory authority or data protection authority in your jurisdiction."
  },
  {
    "type": "paragraph",
    "text": "We encourage you to contact us first at feedback@rareprob.com, and we will do our best to address your concerns promptly and transparently."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Users of California",
    "id": "UsersofCalifornia"
  },
  {
    "type": "paragraph",
    "text": "If you are a California resident, you have the following rights according to CCPA:"
  },
  {
    "type": "listItem",
    "text": "Right to Know: Users have the right to know how their personal information is used or shared. We do not sell your personal data to third parties.",
    "level": 0,
    "ordered": false,
    "numId": "62"
  },
  {
    "type": "listItem",
    "text": "Right to Access: Request information about the personal data we have collected about you.",
    "level": 0,
    "ordered": false,
    "numId": "21"
  },
  {
    "type": "listItem",
    "text": "Right to Delete: Request deletion of your personal data.",
    "level": 0,
    "ordered": false,
    "numId": "37"
  },
  {
    "type": "listItem",
    "text": "Right to Opt-Out: You have the right to opt out of the sale of your personal information. We do not sell your personal data. If this changes, we will update this policy and provide a clear opt-out mechanism.",
    "level": 0,
    "ordered": false,
    "numId": "48"
  },
  {
    "type": "paragraph",
    "text": "To exercise these rights, please contact us at feedback@rareprob.com."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "EU Users",
    "id": "EUUsers"
  },
  {
    "type": "paragraph",
    "text": "For EU users, under the GDPR, you have the right to:"
  },
  {
    "type": "listItem",
    "text": "Right to Access: Request access to your personal data and obtain a copy.",
    "level": 0,
    "ordered": false,
    "numId": "55"
  },
  {
    "type": "listItem",
    "text": "Right to Rectification: Request correction of inaccurate personal data.",
    "level": 0,
    "ordered": false,
    "numId": "55"
  },
  {
    "type": "listItem",
    "text": "Right to Erasure: Request deletion of your personal data.",
    "level": 0,
    "ordered": false,
    "numId": "55"
  },
  {
    "type": "listItem",
    "text": "Right to Restrict Processing: Request restriction of processing your personal data.",
    "level": 0,
    "ordered": false,
    "numId": "55"
  },
  {
    "type": "listItem",
    "text": "Right to Data Portability: Request transfer of your data to another organization.",
    "level": 0,
    "ordered": false,
    "numId": "55"
  },
  {
    "type": "listItem",
    "text": "Right to Object: Object to the processing of your personal data.",
    "level": 0,
    "ordered": false,
    "numId": "55"
  },
  {
    "type": "paragraph",
    "text": "To exercise these rights, please contact us at feedback@rareprob.com."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Users of Brazil",
    "id": "UsersofBrazil"
  },
  {
    "type": "paragraph",
    "text": "If you are in Brazil, you have the following rights under the LGPD:"
  },
  {
    "type": "listItem",
    "text": "Right to Confirmation: Confirm the existence of processing of your personal data.",
    "level": 0,
    "ordered": false,
    "numId": "4"
  },
  {
    "type": "listItem",
    "text": "Right to Access: Access your personal data.",
    "level": 0,
    "ordered": false,
    "numId": "4"
  },
  {
    "type": "listItem",
    "text": "Right to Correction: Correct incomplete, inaccurate, or outdated data.",
    "level": 0,
    "ordered": false,
    "numId": "4"
  },
  {
    "type": "listItem",
    "text": "Right to Deletion: Request deletion of unnecessary or excessive data.",
    "level": 0,
    "ordered": false,
    "numId": "4"
  },
  {
    "type": "listItem",
    "text": "Right to Data Portability: Request transfer of your data to another service provider.",
    "level": 0,
    "ordered": false,
    "numId": "4"
  },
  {
    "type": "listItem",
    "text": "Right to Opposition: Oppose the processing of your personal data in certain situations.",
    "level": 0,
    "ordered": false,
    "numId": "4"
  },
  {
    "type": "paragraph",
    "text": "To exercise these rights, please contact us at feedback@rareprob.com."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Users of Virginia",
    "id": "UsersofVirginia"
  },
  {
    "type": "paragraph",
    "text": "For residents of Virginia, you have certain rights under the Virginia Consumer Data Protection Act (VCDPA), including the right to access, correct, delete, obtain a copy of, and opt out of certain processing of your personal data, including: "
  },
  {
    "type": "heading",
    "level": 3,
    "text": "1. Opt-Out of Targeted Advertising",
    "id": "1OptOutofTargetedAdvertising"
  },
  {
    "type": "paragraph",
    "text": "We use third-party advertising partners (listed in the \"Service Providers for Advertising\" section) that may use your Advertising ID and app usage data to serve targeted ads. You can opt out by:"
  },
  {
    "type": "listItem",
    "text": "Disabling ad personalization in your device settings (Settings → Google → Ads → Opt out of Ads Personalization)",
    "level": 0,
    "ordered": false,
    "numId": "39"
  },
  {
    "type": "listItem",
    "text": "Resetting or limiting your Advertising ID (AAID/IDFA)",
    "level": 0,
    "ordered": false,
    "numId": "39"
  },
  {
    "type": "listItem",
    "text": "Using in-app privacy controls, where available",
    "level": 0,
    "ordered": false,
    "numId": "39"
  },
  {
    "type": "listItem",
    "text": "Emailing feedback@rareprob.com with subject line \"Opt-Out: Targeted Advertising\"",
    "level": 0,
    "ordered": false,
    "numId": "39"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "2. Opt-Out of the Sale of Personal Data",
    "id": "2OptOutoftheSaleofPersonalData"
  },
  {
    "type": "paragraph",
    "text": "We do not sell personal data for money. However, VCDPA broadly defines \"sale\" to include certain exchanges of personal data with third parties (such as advertising and analytics partners) for valuable consideration. To the extent our sharing with advertising partners is considered a \"sale\" under this definition, you may opt out by:"
  },
  {
    "type": "listItem",
    "text": "Emailing feedback@rareprob.com with subject line \"Opt-Out: Sale of Personal Data\"",
    "level": 0,
    "ordered": false,
    "numId": "40"
  },
  {
    "type": "listItem",
    "text": "Disabling ad personalization and resetting your Advertising ID as described above",
    "level": 0,
    "ordered": false,
    "numId": "40"
  },
  {
    "type": "listItem",
    "text": "Enabling a recognized universal opt-out mechanism, such as the Global Privacy Control (GPC), through a supported browser or device setting — where technically supported, we will honor this signal as a valid opt-out request",
    "level": 0,
    "ordered": false,
    "numId": "40"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "3. Opt-Out of Profiling for Legal or Similarly Significant Decisions",
    "id": "3OptOutofProfilingforLegalorSimilarlySignificantDecisions"
  },
  {
    "type": "paragraph",
    "text": "We do not currently use automated profiling to make decisions that produce legal or similarly significant effects for you (such as decisions about credit, employment, housing, healthcare, or insurance). If this changes, you will be able to opt out by emailing feedback@rareprob.com with the subject line \"Opt-Out: Profiling.\""
  },
  {
    "type": "paragraph",
    "text": "We will respond to opt-out requests within the timeframe required by Virginia law and will not discriminate against you for exercising these rights. If we deny your request, you have the right to appeal by contacting us at feedback@rareprob.com with subject line \"Appeal,\" and if your appeal is denied, you may contact the Virginia Attorney General's Office."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "DMCA Copyright Policy",
    "id": "DMCACopyrightPolicy"
  },
  {
    "type": "paragraph",
    "text": "All Content available on the Platform is licensed from third-party services such as YouTube. All copyrights are owned by their respective owners and are used with permission. The Platform only provides outbound links to these Third-Party Services and has no direct control over their content. In compliance with the Digital Millennium Copyright Act, the Company has adopted the following general stance toward copyright infringement."
  },
  {
    "type": "paragraph",
    "text": "YouTube Content: third-party content available through the use of Google’s API (such as text, images, videos, audio, or software) hosted by YouTube."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Infringement policy",
    "id": "Infringementpolicy"
  },
  {
    "type": "paragraph",
    "text": "We respect the intellectual property rights of others and expect our users to do the same. If you believe that your copyrighted work or intellectual property has been used in a way that constitutes infringement within our app, please notify us immediately."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "How to Report Infringement",
    "id": "HowtoReportInfringement"
  },
  {
    "type": "paragraph",
    "text": "If you believe your rights have been violated, please provide us with the following information:"
  },
  {
    "type": "listItem",
    "text": "A description of the copyrighted or intellectual property that you claim has been infringed.",
    "level": 0,
    "ordered": false,
    "numId": "17"
  },
  {
    "type": "listItem",
    "text": "A description of where the material in question is located within the app (such as a link or screenshot).",
    "level": 0,
    "ordered": false,
    "numId": "17"
  },
  {
    "type": "listItem",
    "text": "Your contact information, including your name, email address, and phone number.",
    "level": 0,
    "ordered": false,
    "numId": "17"
  },
  {
    "type": "listItem",
    "text": "A statement that you have a good faith belief that the use of the material is not authorized by the copyright owner, its agent, or the law.",
    "level": 0,
    "ordered": false,
    "numId": "17"
  },
  {
    "type": "listItem",
    "text": "A statement that the information provided in the notification is accurate and that you are the copyright or intellectual property owner or authorized to act on behalf of the owner.",
    "level": 0,
    "ordered": false,
    "numId": "17"
  },
  {
    "type": "paragraph",
    "text": "To submit your infringement claim, please contact us at: feedback@rareprob.com."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "In-App Purchases",
    "id": "InAppPurchases"
  },
  {
    "type": "paragraph",
    "text": "We offer you choices with in-app purchases to improve your user experience and let you explore and take advantage of more features across the platform."
  },
  {
    "type": "paragraph",
    "text": "If you wish to make any purchase, you do so through the Google Play service and also agree to its respective Terms and Conditions."
  },
  {
    "type": "paragraph",
    "text": "https://play.google.com/intl/en-us/about/play-terms/index.html"
  },
  {
    "type": "paragraph",
    "text": "Also, it is to be noted that we’re not a party to any In-app purchases."
  },
  {
    "type": "paragraph",
    "text": "When you make an in-app purchase, your purchase history and subscription status are recorded locally on your device via Google Play Billing. We do not store payment card details. Purchase history is used solely to validate and restore your premium access."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Liability Limitation",
    "id": "LiabilityLimitation"
  },
  {
    "type": "paragraph",
    "text": "ASD Dev Video Player for All Format shall in no event be liable for any loss or damage (incidental, or consequential) of your device or files, including photos, videos, documents, and music, caused by-"
  },
  {
    "type": "listItem",
    "text": "Access or inability to access the services offered in our apps.",
    "level": 0,
    "ordered": false,
    "numId": "56"
  },
  {
    "type": "listItem",
    "text": "Any third party's conduct.",
    "level": 0,
    "ordered": false,
    "numId": "56"
  },
  {
    "type": "listItem",
    "text": "Unauthorized or inappropriate use of our services in mobile applications other than what they were intended for.",
    "level": 0,
    "ordered": false,
    "numId": "56"
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Disclaimer of Warranty",
    "id": "DisclaimerofWarranty"
  },
  {
    "type": "paragraph",
    "text": "Services provided by us, through mobile applications, are provided “as is\" and “as available,” with no warranties (expressed or implied). It also includes, but is not limited to, warranties of quality, marketability, fitness of services for particular purposes, or non-infringement. You use our services at your own risk and only as permitted by law."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Copyright and Trademarks",
    "id": "CopyrightandTrademarks"
  },
  {
    "type": "paragraph",
    "text": "Our apps give users the ability to create their own content. We will never claim ownership of your original work. You alone remain the sole person responsible for every piece of content you create, and therefore, you warrant it.\n\nWe own and retain all rights to its content, applications, and services. Whereas our service and content are protected by copyright, trademark, patent, trade secret, and other laws.\n\nWe also reserve the right to use your feedback (without revealing any personal information about the person who provided it) as we see fit. Under no circumstances can the sender of any particular feedback claim ownership of it or ask for payment in return."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Push Notifications",
    "id": "PushNotifications"
  },
  {
    "type": "paragraph",
    "text": "We provide you with the choice to receive push notifications to inform you of built-in features of the Application or any additional use of the Platform, or you can say enabling In-app notifications is an alternative. If you turn off notifications, you might not get information right away, and you can miss out on the latest updates and information."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Termination",
    "id": "Termination"
  },
  {
    "type": "paragraph",
    "text": "Your access to any particular feature or the entire platform may be terminated if any violation is discovered in any way. The platform may be terminated with or without prior warning, and if, for any reason, you wish to do so, you may do so by deleting the application from your device."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Retention of data",
    "id": "Retentionofdata"
  },
  {
    "type": "paragraph",
    "text": "We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies."
  },
  {
    "type": "paragraph",
    "text": "We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer periods."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Data Recovery Policy",
    "id": "DataRecoveryPolicy"
  },
  {
    "type": "paragraph",
    "text": "Our apps do not support Recoverable action after uninstallation of the app. If users are using the Hider functionality, then it is crucial to remember that you may lose all the trash or hidden data if you clear all your data or factory reset your device."
  },
  {
    "type": "paragraph",
    "text": "To prevent your data from being lost, you may transfer the trash or hidden files from our app to your device because once you uninstall our app, you won't be able to recover those files. Our developers will not be liable for any of the private files or data."
  },
  {
    "type": "paragraph",
    "text": "We prioritize your control over personalized data. You can easily manage and delete your local database, preferences, and logs directly from the app’s settings, without the need to visit any external service or URL. This includes clearing stored information in the local database, resetting your saved preferences, and deleting any logs generated during app usage, such as activity or error logs. All data management actions can be performed entirely within the app, giving you full control over your data without reliance on external platforms. We encourage users to regularly review and manage their data based on personal preferences."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Security of data",
    "id": "Securityofdata"
  },
  {
    "type": "paragraph",
    "text": "The security of your data is important to us, but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security."
  },
  {
    "type": "paragraph",
    "text": "We use industry-standard security measures, including device-based protections such as biometric authentication (fingerprint), to safeguard user data stored within the app. We do not collect any biometric data. It is processed locally on your device."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "OUR POLICY ON “DO NOT TRACK” SIGNALS UNDER THE CALIFORNIA ONLINE PROTECTION ACT (CALOPPA)",
    "id": "OURPOLICYONDONOTTRACKSIGNALSUNDERTHECALIFORNIAONLINEPROTECTIONACTCALOPPA"
  },
  {
    "type": "paragraph",
    "text": "We do not support Do Not Track (“DNT”). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked."
  },
  {
    "type": "paragraph",
    "text": "You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Third-Party Services",
    "id": "ThirdPartyServices"
  },
  {
    "type": "paragraph",
    "text": "We use trusted third-party providers to support our app, such as for analytics and performance. They only access the data needed to perform their services and must keep it secure and confidential."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "Disclaimer:",
    "id": "Disclaimer"
  },
  {
    "type": "paragraph",
    "text": "Our apps are not associated with any social media platform. Any unauthorized acts and/or violations of intellectual property rights are solely the user's responsibility. Before downloading and using the content, we suggest that you seek the permission of the owner."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "1. AI Features – Image Processing",
    "id": "AIFeaturesImageProcessing"
  },
  {
    "type": "paragraph",
    "text": "Our app uses Google's ML Kit and MediaPipe to power certain AI-based image editing features. Specifically, the app uses the following on-device capabilities:"
  },
  {
    "type": "listItem",
    "text": "Face Detection — Detects faces within images to enable features such as auto-framing or smart cropping.",
    "level": 0,
    "ordered": false,
    "numId": "58"
  },
  {
    "type": "listItem",
    "text": "Selfie & Subject Segmentation — Separates the subject (person or object) from the background in images to enable background removal or replacement features.",
    "level": 0,
    "ordered": false,
    "numId": "58"
  },
  {
    "type": "paragraph",
    "text": "Important disclosures regarding these features:"
  },
  {
    "type": "listItem",
    "text": "All processing is performed entirely on your device using Google ML Kit and MediaPipe. No facial data, biometric identifiers, or segmented images are sent to our servers or any third party.",
    "level": 0,
    "ordered": false,
    "numId": "42"
  },
  {
    "type": "listItem",
    "text": "We do not store, share, or use any facial data for identification, profiling, or advertising purposes.",
    "level": 0,
    "ordered": false,
    "numId": "42"
  },
  {
    "type": "listItem",
    "text": "These features only activate when you explicitly use them within the app.",
    "level": 0,
    "ordered": false,
    "numId": "42"
  },
  {
    "type": "listItem",
    "text": "No facial recognition or biometric identification is performed — the app only detects the presence and position of faces to improve image composition.",
    "level": 0,
    "ordered": false,
    "numId": "42"
  },
  {
    "type": "paragraph",
    "text": "If you choose to use our AI-based image-to-image generation or editing features, the app may temporarily process your selected images locally or via secure servers strictly for the purpose of generating results. These images are not stored or shared after processing unless you explicitly save them on your device."
  },
  {
    "type": "paragraph",
    "text": "Note: Our app uses on-device face detection and image segmentation via Google ML Kit solely to enhance image editing features. This processing happens locally on your device and does not constitute biometric identification. No facial data is stored, transmitted, or shared."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "Service Providers for Analytics",
    "id": "ServiceProvidersforAnalytics"
  },
  {
    "type": "heading",
    "text": "1. Facebook Analytics",
    "level": 4,
    "id": "FacebookAnalytics"
  },
  {
    "type": "paragraph",
    "text": "We use Facebook Analytics for in-game data analytics to improve our games.\nFor more information on the privacy practices of Facebook, please visit Facebook’s Data"
  },
  {
    "type": "paragraph",
    "text": "Policy: https://www.facebook.com/privacy/explanation"
  },
  {
    "type": "heading",
    "text": "2. Firebase Services (by Google LLC)",
    "level": 4,
    "id": "FirebaseServices"
  },
  {
    "type": "paragraph",
    "text": "Our app uses multiple Firebase services provided by Google LLC. Each service is described below. If you need more details regarding Firebase Services, feel free to visit: https://firebase.google.com/support/privacy"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "2.1 Firebase Analytics",
    "id": "21FirebaseAnalytics"
  },
  {
    "type": "paragraph",
    "text": "Firebase Analytics helps us improve features, fix issues, and make better product decisions."
  },
  {
    "type": "paragraph",
    "text": "Data collected through Firebase Analytics may be transmitted to and processed on Google servers, which constitutes data sharing with a third-party service provider."
  },
  {
    "type": "paragraph",
    "text": "Data collected includes:"
  },
  {
    "type": "listItem",
    "text": "App events (e.g., app open, screen views, button taps, feature usage)",
    "level": 0,
    "ordered": false,
    "numId": "46"
  },
  {
    "type": "listItem",
    "text": "Device information (model, OS version, language, country)",
    "level": 0,
    "ordered": false,
    "numId": "46"
  },
  {
    "type": "listItem",
    "text": "App version and installation source",
    "level": 0,
    "ordered": false,
    "numId": "46"
  },
  {
    "type": "listItem",
    "text": "Session duration and frequency of use",
    "level": 0,
    "ordered": false,
    "numId": "46"
  },
  {
    "type": "listItem",
    "text": "Advertising ID (AAID on Android / IDFA on iOS)",
    "level": 0,
    "ordered": false,
    "numId": "46"
  },
  {
    "type": "listItem",
    "text": "Crash and ANR (App Not Responding) events",
    "level": 0,
    "ordered": false,
    "numId": "46"
  },
  {
    "type": "paragraph",
    "text": "Important disclosures:"
  },
  {
    "type": "listItem",
    "text": "Firebase Analytics data is pseudonymized, which means it is associated with a device identifier, not your name or personal identity",
    "level": 0,
    "ordered": false,
    "numId": "1"
  },
  {
    "type": "listItem",
    "text": "We do not use Firebase Analytics to access your photos, videos, or any personal files",
    "level": 0,
    "ordered": false,
    "numId": "1"
  },
  {
    "type": "listItem",
    "text": "Analytics data may be linked with other Firebase services, such as Remote Config and Crashlytics, for a unified view of app performance",
    "level": 0,
    "ordered": false,
    "numId": "1"
  },
  {
    "type": "paragraph",
    "text": "You can opt out of Firebase Analytics data collection at any time by disabling ad personalization in your device settings or by resetting your Advertising ID. On Android, go to Settings → Google → Ads → Reset Advertising ID or Opt Out of Ads Personalization."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "2.2 Firebase Crashlytics",
    "id": "22FirebaseCrashlytics"
  },
  {
    "type": "paragraph",
    "text": "We use Firebase Crashlytics to automatically detect, log, and report app crashes and stability issues. This allows our team to identify and fix bugs quickly to improve your experience."
  },
  {
    "type": "paragraph",
    "text": "Data collected includes:"
  },
  {
    "type": "listItem",
    "text": "Crash stack traces (technical logs showing where the app failed)",
    "level": 0,
    "ordered": false,
    "numId": "52"
  },
  {
    "type": "listItem",
    "text": "Device state at the time of the crash (OS version, device model, available memory)",
    "level": 0,
    "ordered": false,
    "numId": "52"
  },
  {
    "type": "listItem",
    "text": "App version and build number",
    "level": 0,
    "ordered": false,
    "numId": "52"
  },
  {
    "type": "listItem",
    "text": "A randomly generated Crashlytics Installation UUID to track crash frequency per device",
    "level": 0,
    "ordered": false,
    "numId": "52"
  },
  {
    "type": "listItem",
    "text": "Whether the app was in the foreground or background",
    "level": 0,
    "ordered": false,
    "numId": "52"
  },
  {
    "type": "paragraph",
    "text": "Important disclosures:"
  },
  {
    "type": "listItem",
    "text": "Crashlytics does not collect your name, email address, photos, videos, or any personal content",
    "level": 0,
    "ordered": false,
    "numId": "2"
  },
  {
    "type": "listItem",
    "text": "Crash logs are anonymized and contain only technical diagnostic information",
    "level": 0,
    "ordered": false,
    "numId": "2"
  },
  {
    "type": "listItem",
    "text": "Logs are used solely for debugging and stability improvement and never for advertising or profiling",
    "level": 0,
    "ordered": false,
    "numId": "2"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "2.3 Firebase Remote Config",
    "id": "23FirebaseRemoteConfig"
  },
  {
    "type": "paragraph",
    "text": "We use Firebase Remote Config to update certain app settings, features, and content remotely without requiring you to download a new version of the app. This allows us to roll out features gradually, run A/B tests, or make quick adjustments to the app experience."
  },
  {
    "type": "paragraph",
    "text": "Data collected includes:"
  },
  {
    "type": "listItem",
    "text": "Firebase Installation ID (to identify the app instance for targeted configuration delivery)",
    "level": 0,
    "ordered": false,
    "numId": "11"
  },
  {
    "type": "listItem",
    "text": "App version and platform information",
    "level": 0,
    "ordered": false,
    "numId": "11"
  },
  {
    "type": "listItem",
    "text": "User property segments (e.g., app version group, country) are used to determine which configuration to deliver",
    "level": 0,
    "ordered": false,
    "numId": "11"
  },
  {
    "type": "paragraph",
    "text": "Important disclosures:"
  },
  {
    "type": "listItem",
    "text": "Remote Config does not collect personal content such as your photos, files, or browsing activity",
    "level": 0,
    "ordered": false,
    "numId": "57"
  },
  {
    "type": "listItem",
    "text": "It does not enable us to access or modify anything on your device remotely. It only controls settings within our app",
    "level": 0,
    "ordered": false,
    "numId": "57"
  },
  {
    "type": "listItem",
    "text": "Configuration data fetched from Firebase is stored locally on your device",
    "level": 0,
    "ordered": false,
    "numId": "57"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "2.4 Firebase Cloud Messaging",
    "id": "24FirebaseCloudMessaging"
  },
  {
    "type": "paragraph",
    "text": "We use Firebase Cloud Messaging to send push notifications to your device. These notifications may include app updates, feature announcements, reminders, or promotional messages related to our app."
  },
  {
    "type": "paragraph",
    "text": "Data collected includes:"
  },
  {
    "type": "listItem",
    "text": "FCM Registration Token (a unique token assigned to your app installation, used to route notifications to your device)",
    "level": 0,
    "ordered": false,
    "numId": "33"
  },
  {
    "type": "listItem",
    "text": "Device platform and app version (to ensure notification compatibility)",
    "level": 0,
    "ordered": false,
    "numId": "33"
  },
  {
    "type": "paragraph",
    "text": "Important disclosures:"
  },
  {
    "type": "listItem",
    "text": "The FCM token is a technical identifier — it does not contain your name, email, or any personal identity information",
    "level": 0,
    "ordered": false,
    "numId": "5"
  },
  {
    "type": "listItem",
    "text": "We do not use FCM to collect data about your notification interactions beyond what is necessary to deliver the notification",
    "level": 0,
    "ordered": false,
    "numId": "5"
  },
  {
    "type": "listItem",
    "text": "You can disable push notifications at any time through your device settings.",
    "level": 0,
    "ordered": false,
    "numId": "5"
  },
  {
    "type": "listItem",
    "text": "On Android 13 and above, we request your explicit permission before sending any notifications",
    "level": 0,
    "ordered": false,
    "numId": "5"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "2.5 Firebase Performance Monitoring",
    "id": "25FirebasePerformanceMonitoring"
  },
  {
    "type": "paragraph",
    "text": "We use Firebase Performance Monitoring to measure and improve the technical performance of our app. This SDK automatically collects data such as app startup time, screen rendering performance, network request response times, and crash traces."
  },
  {
    "type": "paragraph",
    "text": "Data collected includes:"
  },
  {
    "type": "listItem",
    "text": "App version and device information (model, OS version)",
    "level": 0,
    "ordered": false,
    "numId": "59"
  },
  {
    "type": "listItem",
    "text": "Network request URLs, response codes, and payload sizes",
    "level": 0,
    "ordered": false,
    "numId": "59"
  },
  {
    "type": "listItem",
    "text": "Screen rendering frame rates",
    "level": 0,
    "ordered": false,
    "numId": "59"
  },
  {
    "type": "listItem",
    "text": "App start-up duration",
    "level": 0,
    "ordered": false,
    "numId": "59"
  },
  {
    "type": "paragraph",
    "text": "This data is used solely to diagnose and fix performance issues. It does not include personal content such as photos, videos, or user-generated files."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "2.6 Firebase In-App Messaging",
    "id": "26FirebaseInAPPMessaging"
  },
  {
    "type": "paragraph",
    "text": "We use Firebase In-App Messaging to display contextual messages, tips, or promotional content to users who are actively using the app. These messages may include feature announcements, tips, or promotional offers."
  },
  {
    "type": "paragraph",
    "text": "Data collected includes:"
  },
  {
    "type": "listItem",
    "text": "Firebase Installation ID (to identify the app instance)",
    "level": 0,
    "ordered": false,
    "numId": "19"
  },
  {
    "type": "listItem",
    "text": "App engagement data (to determine when and to whom messages are shown)",
    "level": 0,
    "ordered": false,
    "numId": "19"
  },
  {
    "type": "paragraph",
    "text": "No personal content from your device is accessed. Messages are triggered based on in-app behavior (e.g., opening a feature) and not based on personal identity."
  },
  {
    "type": "heading",
    "level": 0,
    "text": "2.7 Firebase Realtime Database",
    "id": "27RealtimeDatabase"
  },
  {
    "type": "listItem",
    "text": "We use Firebase Realtime Database to store and sync app data in real time. This may include app configuration data, user preferences, or feature-related data necessary for the app to function correctly.",
    "level": 0,
    "ordered": false,
    "numId": "13"
  },
  {
    "type": "listItem",
    "text": "Data stored in the database is protected by Firebase's security rules and is only accessible to authorized app functions. We do not store sensitive personal information such as payment details, precise location, or biometric data in this database.",
    "level": 0,
    "ordered": false,
    "numId": "13"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "2.8 Firebase AI / Gemini API",
    "id": "28FirebaseAIGeminiAPI"
  },
  {
    "type": "paragraph",
    "text": "We use Firebase AI (powered by Google's Gemini models) to enable AI-powered"
  },
  {
    "type": "paragraph",
    "text": "features within the app, such as image editing, content generation, or intelligent"
  },
  {
    "type": "paragraph",
    "text": "suggestions."
  },
  {
    "type": "paragraph",
    "text": "When you use an AI-powered feature:"
  },
  {
    "type": "listItem",
    "text": "Your input (such as a selected image or text prompt) may be temporarily processed by Google's AI infrastructure to generate a result",
    "level": 0,
    "ordered": false,
    "numId": "9"
  },
  {
    "type": "listItem",
    "text": "Inputs are not used to train Google's AI models without your consent",
    "level": 0,
    "ordered": false,
    "numId": "9"
  },
  {
    "type": "listItem",
    "text": "Processed data is not retained by Google beyond the immediate session unless explicitly stated",
    "level": 0,
    "ordered": false,
    "numId": "9"
  },
  {
    "type": "paragraph",
    "text": "For more information on how Google handles AI data, visit: https://ai.google.dev/gemini-api/terms"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "Service Providers for Advertising",
    "id": "ServiceProvidersforAdvertising"
  },
  {
    "type": "paragraph",
    "text": "We reserve the right to place adverts on the platforms in order to maintain the free functionalities. These advertisements may be interspersed with other features, and some of those features may only be activated if you view the ads. If you choose to stop seeing certain adverts, you might lose access to those features or encounter other app restrictions."
  },
  {
    "type": "paragraph",
    "text": "Your use of the App may be terminated if you use any method to get around any In-app advertisements."
  },
  {
    "type": "paragraph",
    "text": "Before displaying any personalized advertisements, we use Google's User Messaging Platform (UMP) to request your consent in accordance with applicable privacy laws. You may update your ad consent preferences at any time through the app's settings."
  },
  {
    "type": "paragraph",
    "text": "Our app uses Android's Privacy Sandbox APIs, including the Topics API, Custom Audiences API, and Attribution API. These APIs are provided by Google and are used to serve interest-based advertisements and measure ad performance without relying on cross-app identifiers. Data processed through these APIs is handled in accordance with Google's Privacy Sandbox policies. You can opt out through your device's Ad Privacy settings under Settings → Google → Ads."
  },
  {
    "type": "heading",
    "level": 4,
    "text": "1. Google User Messaging Platform / Funding Choices (by Google LLC)",
    "id": "GoogleUserMessagingPlatformFundingChoices"
  },
  {
    "type": "paragraph",
    "text": "Our app uses Google's User Messaging Platform (UMP) SDK to manage advertising consent in compliance with applicable privacy regulations including GDPR, CCPA, and India's DPDP Act."
  },
  {
    "type": "paragraph",
    "text": "When you first open the app (or when regulations require), UMP displays a consent dialog asking whether you agree to personalized advertising. Your response is recorded and transmitted to Google's Funding Choices service, which then communicates your consent signal to our advertising partners."
  },
  {
    "type": "paragraph",
    "text": "What this SDK does:"
  },
  {
    "type": "listItem",
    "text": "Displays consent dialogs required by GDPR (for EU/UK users), CCPA (for California users), and other applicable laws",
    "level": 0,
    "ordered": false,
    "numId": "41"
  },
  {
    "type": "listItem",
    "text": "Stores your consent preference on your device",
    "level": 0,
    "ordered": false,
    "numId": "41"
  },
  {
    "type": "listItem",
    "text": "Transmits your consent signal to Google and our ad network partners so they can serve ads in accordance with your choice",
    "level": 0,
    "ordered": false,
    "numId": "41"
  },
  {
    "type": "listItem",
    "text": "Determines which ad experience you receive — personalized or non-personalized — based on your response",
    "level": 0,
    "ordered": false,
    "numId": "41"
  },
  {
    "type": "paragraph",
    "text": "Data involved:"
  },
  {
    "type": "listItem",
    "text": "Your consent choice (yes/no to personalized ads)",
    "level": 0,
    "ordered": false,
    "numId": "22"
  },
  {
    "type": "listItem",
    "text": "Your approximate region/jurisdiction (to determine which consent rules apply)",
    "level": 0,
    "ordered": false,
    "numId": "22"
  },
  {
    "type": "listItem",
    "text": "A timestamp of when consent was given or denied",
    "level": 0,
    "ordered": false,
    "numId": "22"
  },
  {
    "type": "paragraph",
    "text": "No sensitive personal data is collected by this SDK. It acts solely as a consent management mechanism."
  },
  {
    "type": "paragraph",
    "text": "For more information, visit Google's Privacy Policy: https://policies.google.com/privac"
  },
  {
    "type": "paragraph",
    "text": "For Funding Choices documentation: https://support.google.com/fundingchoices/"
  },
  {
    "type": "heading",
    "level": 4,
    "text": "2. Facebook Audience Network (by Facebook Inc.)",
    "id": "FacebookAudienceNetwork"
  },
  {
    "type": "paragraph",
    "text": "For more information about Facebook Audience Network, please visit their Policy: https://developers.facebook.com/docs/audience-network/optimization/best-practices/an-policy/"
  },
  {
    "type": "heading",
    "level": 4,
    "text": "3. Facebook Marketing (part of Meta Business)",
    "id": "FacebookMarketing"
  },
  {
    "type": "paragraph",
    "text": "The purpose of this SDK is Analytics, ad attribution, and personalized advertising. It collects the following types of data: device information, advertising ID, app events, and usage data. The data usage is to measure ad performance and deliver relevant ads. You can also check their privacy policy - https://www.facebook.com/privacy/policy/"
  },
  {
    "type": "heading",
    "level": 4,
    "text": "4. AdMob (by Google Inc.)",
    "id": "AdMob"
  },
  {
    "type": "paragraph",
    "text": "Understand how “the end-user data collected by Google Mobile Ads SDK” from the link below-"
  },
  {
    "type": "paragraph",
    "text": "https://developers.google.com/admob/android/privacy/play-data-disclosure"
  },
  {
    "type": "paragraph",
    "text": "You can opt-out from the AdMob by Google service by following the instructions described by Google:"
  },
  {
    "type": "paragraph",
    "text": "https://support.google.com/My-Ad-Center-Help/answer/12155764?hl=en"
  },
  {
    "type": "paragraph",
    "text": "For more information on how Google uses the collected information, please visit the “How Google uses data when you use our partners’ sites or app” page:"
  },
  {
    "type": "paragraph",
    "text": "https://policies.google.com/technologies/partner-sites or visit the Privacy Policy of Google: https://policies.google.com/privacy"
  },
  {
    "type": "heading",
    "level": 4,
    "text": "5. AppLovin (by AppLovin Corporation)",
    "id": "AppLovin"
  },
  {
    "type": "paragraph",
    "text": "If you’d like to opt out of AppLovin service, please visit the AppLovin Opt-out page: https://dash.applovin.com/p/how-applovin-shows-you-ads\nIf you’d like to learn more about AppLovin, please visit the Privacy Policy page of AppLovin: https://www.applovin.com/privacy/"
  },
  {
    "type": "heading",
    "level": 4,
    "text": "6. Pangle (by Bytedance Pte.Ltd.)",
    "id": "Pangle"
  },
  {
    "type": "paragraph",
    "text": "For more information about Pangle, please visit their Privacy Policy: https://ad.oceanengine.com/union/media/privacy"
  },
  {
    "type": "heading",
    "level": 4,
    "text": "7. Outbrain(by Teads Holding Co.)",
    "id": "Outbrain"
  },
  {
    "type": "paragraph",
    "text": "Outbrain is a content recommendation and native advertising network. We use it to display sponsored content recommendations in the app to generate revenue that supports our free features."
  },
  {
    "type": "paragraph",
    "text": "Data collected includes- unique user identifier (UUID), IP address (truncated to mask identifying information), mobile advertising IDs (such as IDFA or AAID), and content interaction data to serve recommendations based on inferred user interests. It does not conduct cross-device tracking and cannot link a user interacting on their phone to the same user on another device."
  },
  {
    "type": "paragraph",
    "text": "For more details, please check- https://www.outbrain.com/privacy/user-policy/"
  },
  {
    "type": "heading",
    "level": 4,
    "text": "8. Teads(by Teads Inc.)",
    "id": "Teads"
  },
  {
    "type": "paragraph",
    "text": "Teads is an outstream video and display advertising platform. We use it to serve video ad formats within the app, enabling monetization through high-quality video placements."
  },
  {
    "type": "paragraph",
    "text": "The data it collects includes device IDs, IP addresses, browsing history (content viewed), product interactions (such as app launches, taps, and clicks), and advertising data, such as information about ads the user has seen. Teads does not knowingly collect or process special categories of sensitive data."
  },
  {
    "type": "paragraph",
    "text": "To opt out of its advertising services or for more details, please check- https://privacy-policy.teads.com/"
  },
  {
    "type": "paragraph",
    "text": "For GDPR or CCPA requests, contact dpo@teads.com."
  },
  {
    "type": "heading",
    "level": 4,
    "text": "9. Zemanta (Outbrain DSP)",
    "id": "ZemantaOutbrainDSP"
  },
  {
    "type": "paragraph",
    "text": "We use it to enable programmatic ad buying that automatically matches the most relevant ads to users in real time."
  },
  {
    "type": "paragraph",
    "text": "The data it collects are as follows-"
  },
  {
    "type": "paragraph",
    "text": "Advertising IDs (like IDFA), which are unique IDs associated with individual mobile devices, are used to build a user profile. Users can reset these IDs by instructing their device to do so. It also collects IP addresses, device identifiers, and browsing/interaction signals for ad targeting purposes."
  },
  {
    "type": "paragraph",
    "text": "You can get more information about it through its Privacy Policy:"
  },
  {
    "type": "paragraph",
    "text": "https://www.outbrain.com/privacy/privacy-policy-outbrain-dsp/"
  },
  {
    "type": "paragraph",
    "text": "If you want to opt-out of its advertising services, feel free to check:"
  },
  {
    "type": "paragraph",
    "text": "https://www.zemanta.com/opt-out/"
  },
  {
    "type": "paragraph",
    "text": "And, to check their advertising guidelines, check:"
  },
  {
    "type": "paragraph",
    "text": "https://www.zemanta.com/advertising-guidelines/"
  },
  {
    "type": "heading",
    "level": 4,
    "text": "10. Xandr/ AppNexus (by Microsoft)",
    "id": "XandrAppNexus"
  },
  {
    "type": "paragraph",
    "text": "We use it to access a broad marketplace of advertisers through real-time bidding, helping us maximize ad revenue while maintaining app quality."
  },
  {
    "type": "paragraph",
    "text": "Xandr enables advertising purposes through the use of non-personally identifiable information, which includes browser type, cookie ID, IP address, device identifiers, web pages or apps visited or used, and date and time that web pages or apps were visited. Xandr's mobile SDKs include client support for the Global Privacy Platform (GPP), GDPR, CCPA, and the Digital Services Act (DSA)."
  },
  {
    "type": "paragraph",
    "text": "For more details, you can check- https://help.ads.microsoft.com/#apex/ads/en/ext60205"
  },
  {
    "type": "paragraph",
    "text": "To opt out of personalized advertising from Xandr (Microsoft), visit Microsoft's Privacy Statement at https://privacy.microsoft.com/en-us/privacystatement and navigate to the ad settings section. You can also opt out through your mobile device's advertising settings by limiting ad tracking on Android."
  },
  {
    "type": "heading",
    "level": 4,
    "text": "11. Index Exchange/ Casale Media (by Index Exchange Inc.)",
    "id": "IndexExchangeCasaleMedia"
  },
  {
    "type": "paragraph",
    "text": "Index Exchange (formerly Casale Media) is a supply-side advertising exchange. We use it to make our app's ad inventory available to a wider pool of buyers through programmatic auctions, increasing competition for ad slots and maximizing revenue."
  },
  {
    "type": "paragraph",
    "text": "It collects cookies for the purpose of tracking when a user has seen an advertisement."
  },
  {
    "type": "paragraph",
    "text": "These cookies do not provide personally identifiable information. They are used to inform the exchange whether an advertisement has been served to the same device before, and to facilitate retargeting at a campaign level. Unique user identification numbers are deleted after 90 days of user inactivity and are not tied to any personally identifiable information."
  },
  {
    "type": "paragraph",
    "text": "For more details, you can check- https://www.indexexchange.com/privacy/exchange-platform-privacy-policy/"
  },
  {
    "type": "paragraph",
    "text": "And, you can opt out of targeted advertising through the NAI opt-out tool at https://optout.networkadvertising.org/ or by adjusting your mobile device's advertising ID settings."
  },
  {
    "type": "heading",
    "level": 4,
    "text": "12. CHEQ / CheqZone (by CHEQ AI Technologies)",
    "id": "CHEQCheqZone"
  },
  {
    "type": "paragraph",
    "text": "We use it to protect our advertising ecosystem from invalid traffic, bot activity, and click fraud, to ensure our ad partners receive genuine impressions and to protect our app's revenue integrity."
  },
  {
    "type": "paragraph",
    "text": "CHEQ uses the IP address to determine whether a session is fraudulent. This information is considered personal data under GDPR. CHEQ processes personal data only as necessary to provide its fraud detection services, and data collected is used only for this purpose. CHEQ does not use cookies to track users across websites or for any advertising or targeting purposes. Its cookies are top-level domain cookies used solely to block fraudulent traffic."
  },
  {
    "type": "paragraph",
    "text": "For more details, please check- https://cheq.ai/data-privacy/"
  },
  {
    "type": "paragraph",
    "text": "Users can contact CHEQ directly at privacy@cheq.ai for data subject requests or if they want to opt out of its services."
  },
  {
    "type": "heading",
    "level": 4,
    "text": "13. Vungle (by Vungle Inc.)",
    "id": "Vungle"
  },
  {
    "type": "paragraph",
    "text": "You can opt out of Vungle service by following the instructions as described by Vungle on their Privacy Policy page. If you need more information, check-  http://vungle.com/privacy/"
  },
  {
    "type": "heading",
    "level": 4,
    "text": "14. Mintegral (by Mintegral International Ltd.)",
    "id": "Mintegral"
  },
  {
    "type": "paragraph",
    "text": "For more information about Mintegral, please visit their Privacy Policy: https://www.mintegral.com/en/privacy/"
  },
  {
    "type": "heading",
    "level": 4,
    "text": "15. Unity Ads (by Unity)",
    "id": "UnityAds"
  },
  {
    "type": "paragraph",
    "text": "For more information about Unity Ads, please visit their Privacy Policy: https://unity.com/legal/privacy-policy"
  },
  {
    "type": "heading",
    "level": 4,
    "text": "16. InMobi (by InMobi Pvt. Ltd.)",
    "id": "InMobi"
  },
  {
    "type": "paragraph",
    "text": "You can opt out of the InMobi service by following the instructions as described on the InMobi Opt-out page: https://advertising.inmobi.com/page/opt-out\nFor more information on the privacy practices and policies of InMobi, please visit the InMobi Privacy Policy: https://advertising.inmobi.com/privacy-policy"
  },
  {
    "type": "heading",
    "level": 4,
    "text": "17. Google AdSense & DoubleClick Cookie",
    "id": "GoogleAdSenseDoubleClickCookie"
  },
  {
    "type": "paragraph",
    "text": "Google, as a third-party vendor, uses cookies to serve ads on our Service. Google's use of the DoubleClick cookie enables it and its partners to serve ads to our users based on their visit to our Service or other websites on the Internet. You may opt out of the use of the DoubleClick Cookie for interest-based advertising by visiting the Google Ads Settings web page: https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "Service Providers for Behavioral Remarketing",
    "id": "ServiceProvidersforBehavioralRemarketing"
  },
  {
    "type": "paragraph",
    "text": "We use remarketing services to advertise on third-party websites to you after you visit our Service. Our third-party vendors, and we use cookies to inform, optimise and serve ads based on your past visits to our Service."
  },
  {
    "type": "heading",
    "text": "1. Google Ads",
    "level": 4,
    "id": "GoogleAds"
  },
  {
    "type": "paragraph",
    "text": "Google AdWords remarketing service is provided by Google Inc.\nYou can opt out of Google Analytics for Display Advertising and customise the Google Display Network ads by visiting the Google Ads Settings page: https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings\nGoogle also recommends installing the Google Analytics Opt-out Browser Add-on – https://tools.google.com/dlpage/gaoptout – for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics.\nFor more information on the privacy practices of Google, please visit the Google Privacy & Terms web page: https://policies.google.com/privacy?hl=en"
  },
  {
    "type": "heading",
    "text": "2. Facebook Ads",
    "level": 4,
    "id": "FacebookAds"
  },
  {
    "type": "paragraph",
    "text": "Facebook remarketing service is provided by Facebook Inc.\nYou can learn more about interest-based advertising from Facebook by visiting this page: https://www.facebook.com/business/help/488043719226449?id=434838534925385"
  },
  {
    "type": "paragraph",
    "text": "To opt-out from Facebook’s interest-based ads, follow these instructions from Facebook: https://www.facebook.com/help/568137493302217"
  },
  {
    "type": "paragraph",
    "text": "Facebook adheres to the Self-Regulatory Principles for Online Behavioural Advertising established by the Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies through the Digital Advertising Alliance in the USA https://optout.aboutads.info/?c=2&lang=EN, the Digital Advertising Alliance of Canada in Canada https://optout.aboutads.info/?c=2&lang=EN, or the European Interactive Digital Advertising Alliance in Europe http://www.youronlinechoices.eu/, or opt out using your mobile device settings."
  },
  {
    "type": "paragraph",
    "text": "For more information on the privacy practices of Facebook, please visit Facebook’s Data Policy: https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0"
  },
  {
    "type": "heading",
    "text": "3. AppLovin (by AppLovin Corporation)",
    "level": 4,
    "id": "AppLovin"
  },
  {
    "type": "paragraph",
    "text": "If you’d like to opt out of AppLovin service, please visit the AppLovin Opt-out page:https://dash.applovin.com/p/how-applovin-shows-you-ads\nIf you’d like to learn more about AppLovin, please visit the Privacy Policy page of AppLovin:https://www.applovin.com/privacy/"
  },
  {
    "type": "heading",
    "text": "4. Other Social Media Platforms",
    "level": 4,
    "id": "OtherSocialMediaPlaTFORMS"
  },
  {
    "type": "paragraph",
    "text": "We may use your information to send you marketing and promotional communications about our apps and services. This includes updates, special offers, and news related to our products. You may receive these communications through various channels, including email, push notifications, or in-app messaging."
  },
  {
    "type": "paragraph",
    "text": "To promote our apps and engage with users, we also use a variety of social media platforms such as:"
  },
  {
    "type": "socialItem",
    "label": "Facebook",
    "text": "Rareprob- https://www.facebook.com/rareprob"
  },
  {
    "type": "socialItem",
    "label": "Instagram",
    "text": "Rareprob- https://www.instagram.com/rareprob_/"
  },
  {
    "type": "socialItem",
    "label": "X (formerly Twitter)",
    "text": "Rareprob- https://x.com/rareprob"
  },
  {
    "type": "socialItem",
    "label": "LinkedIn",
    "text": "Rareprob- https://www.linkedin.com/company/rareprob/mycompany/"
  },
  {
    "type": "socialItem",
    "label": "YouTube",
    "text": "Rareprob- https://www.youtube.com/channel/UCNXZXijMtxueoWaNiye73AQ"
  },
  {
    "type": "socialItem",
    "label": "Pinterest",
    "text": "Rareprob- https://pin.it/UfXhnCWtj"
  },
  {
    "type": "paragraph",
    "text": "These platforms allow us to share updates, features, and promotional content, and interact with users who follow our accounts. Please note that while we use these platforms to advertise and promote our apps, we do not share your personal information with these social networks unless you specifically opt in or interact with our content directly on their platforms."
  },
  {
    "type": "paragraph",
    "text": "If you do not wish to receive marketing communications, you can opt-out by following the unsubscribe instructions provided in any email or contacting us directly."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Payments",
    "id": "Payments"
  },
  {
    "type": "paragraph",
    "text": "We may provide paid products and/or services within the Service. In that case, we use third-party services for payment processing (e.g. payment processors)."
  },
  {
    "type": "paragraph",
    "text": "We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information."
  },
  {
    "type": "paragraph",
    "text": "The payment processors we work with are:"
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Google Play In-App Payments",
    "id": "GooglePlayInAppPayments"
  },
  {
    "type": "paragraph",
    "text": "Their Privacy Policy can be viewed at https://policies.google.com/privacy"
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Links to other sites",
    "id": "Linkstoothersites"
  },
  {
    "type": "paragraph",
    "text": "Our Service may contain links to other sites that are not operated by us. If you click a third-party link, you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy of every site you visit. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Children’s Privacy",
    "id": "ChildrensPrivacy"
  },
  {
    "type": "paragraph",
    "text": "Our products and services are designed for users who are 13 years of age or older (or the age specified by law in your country/region). If you are a guardian of a child under the age of 13 (or the legal age in your country/region), we encourage you to actively guide and supervise the child during their use of our products, ensuring the safety of their personal information."
  },
  {
    "type": "paragraph",
    "text": "We advise child users under 13 (or the prescribed age in your country/region) to carefully read this policy with the assistance of a parent or guardian before using our services. All services or the provision of information should only be done with parental or guardian consent. If we discover that we have inadvertently collected personal information from a child, we will take swift action to delete the data."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "Sharing of Children’s Personal Information",
    "id": "SharingofChildrensPersonalInformation"
  },
  {
    "type": "paragraph",
    "text": "We are committed to protecting children’s privacy."
  },
  {
    "type": "listItem",
    "text": "We do not sell, rent, or share children’s personal information with third parties for marketing or advertising purposes.",
    "level": 0,
    "ordered": false,
    "numId": "53"
  },
  {
    "type": "listItem",
    "text": "We do not allow third-party SDKs or ad networks to collect personal data from children for behavioral advertising.",
    "level": 0,
    "ordered": false,
    "numId": "53"
  },
  {
    "type": "listItem",
    "text": "Any third-party services used in the app are strictly limited to:",
    "level": 0,
    "ordered": false,
    "numId": "53"
  },
  {
    "type": "listItem",
    "text": "Supporting internal operations",
    "level": 1,
    "ordered": false,
    "numId": "53"
  },
  {
    "type": "listItem",
    "text": "Ensuring app functionality (such as analytics, crash reporting, or hosting)",
    "level": 1,
    "ordered": false,
    "numId": "53"
  },
  {
    "type": "paragraph",
    "text": "These third parties are required to comply with COPPA (Children’s Online Privacy Protection Act) and other applicable child data protection laws."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "Public Display and Sharing of Information by Children",
    "id": "PublicDisplayandSharingofInformationbyChildren"
  },
  {
    "type": "paragraph",
    "text": "Our apps are designed to be safe for children."
  },
  {
    "type": "listItem",
    "text": "We do not allow children to publicly share or publish personal information (such as full name, address, phone number, or email).",
    "level": 0,
    "ordered": false,
    "numId": "45"
  },
  {
    "type": "listItem",
    "text": "If the app includes features like:",
    "level": 0,
    "ordered": false,
    "numId": "45"
  },
  {
    "type": "listItem",
    "text": "Usernames",
    "level": 1,
    "ordered": false,
    "numId": "45"
  },
  {
    "type": "listItem",
    "text": "Leaderboards",
    "level": 1,
    "ordered": false,
    "numId": "45"
  },
  {
    "type": "listItem",
    "text": "Game profiles",
    "level": 1,
    "ordered": false,
    "numId": "45"
  },
  {
    "type": "paragraph",
    "text": "These are designed to:"
  },
  {
    "type": "listItem",
    "text": "Avoid the collection of personally identifiable information",
    "level": 0,
    "ordered": false,
    "numId": "61"
  },
  {
    "type": "listItem",
    "text": "Prevent public exposure of sensitive data",
    "level": 0,
    "ordered": false,
    "numId": "61"
  },
  {
    "type": "listItem",
    "text": "Use anonymized or non-identifiable data only",
    "level": 0,
    "ordered": false,
    "numId": "61"
  },
  {
    "type": "paragraph",
    "text": "We actively take steps to prevent accidental sharing of personal information by children."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Parental and Caregiver Rights (Children’s Data Rights)",
    "id": "ParentalandCaregiverRightsChildrensDataRights"
  },
  {
    "type": "paragraph",
    "text": "In accordance with the Children’s Online Privacy Protection Act (COPPA) and other global privacy regulations, parents and legal guardians have the following rights regarding their child’s personal information."
  },
  {
    "type": "paragraph",
    "text": "We clearly inform caregivers that they have the right to review, delete, and control the collection and use of their child’s personal data."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "1. Right to Review Child’s Data",
    "id": "1RighttoReviewChildsData"
  },
  {
    "type": "paragraph",
    "text": "Parents or legal guardians have the right to request access to the personal information we may have collected from their child."
  },
  {
    "type": "paragraph",
    "text": "To request review access:"
  },
  {
    "type": "listItem",
    "text": "Email us at feedback@rareprob.com",
    "level": 0,
    "ordered": false,
    "numId": "31"
  },
  {
    "type": "listItem",
    "text": "Use subject line: “Review Child Data”",
    "level": 0,
    "ordered": false,
    "numId": "31"
  },
  {
    "type": "listItem",
    "text": "Provide necessary verification details",
    "level": 0,
    "ordered": false,
    "numId": "31"
  },
  {
    "type": "paragraph",
    "text": "We will respond within a reasonable timeframe after verifying your identity."
  },
  {
    "type": "heading",
    "level": 3,
    "text": "2. Right to Delete Child’s Data",
    "id": "2RighttoDeleteChildsData"
  },
  {
    "type": "paragraph",
    "text": "Parents have the right to request deletion of their child’s personal information."
  },
  {
    "type": "paragraph",
    "text": "To request deletion:"
  },
  {
    "type": "listItem",
    "text": "Email us at feedback@rareprob.com",
    "level": 0,
    "ordered": false,
    "numId": "63"
  },
  {
    "type": "listItem",
    "text": "Use subject line: “Delete Child Data”",
    "level": 0,
    "ordered": false,
    "numId": "63"
  },
  {
    "type": "paragraph",
    "text": "Once verified:"
  },
  {
    "type": "listItem",
    "text": "We will delete the data securely",
    "level": 0,
    "ordered": false,
    "numId": "12"
  },
  {
    "type": "listItem",
    "text": "Retention will only occur if required by law",
    "level": 0,
    "ordered": false,
    "numId": "12"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "3. Right to Stop Data Collection or Use",
    "id": "3RighttoStopDataCollectionorUse"
  },
  {
    "type": "paragraph",
    "text": "Parents can request that we stop collecting or using their child’s data at any time."
  },
  {
    "type": "paragraph",
    "text": "To exercise this right:"
  },
  {
    "type": "listItem",
    "text": "Email: feedback@rareprob.com",
    "level": 0,
    "ordered": false,
    "numId": "27"
  },
  {
    "type": "listItem",
    "text": "Subject: “Stop Data Collection”",
    "level": 0,
    "ordered": false,
    "numId": "27"
  },
  {
    "type": "paragraph",
    "text": "After processing:"
  },
  {
    "type": "listItem",
    "text": "We will stop collecting personal data",
    "level": 0,
    "ordered": false,
    "numId": "54"
  },
  {
    "type": "listItem",
    "text": "Some features of the app may no longer function properly",
    "level": 0,
    "ordered": false,
    "numId": "54"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "4. Right to Withdraw Consent",
    "id": "4RighttoWithdrawConsent"
  },
  {
    "type": "paragraph",
    "text": "If consent was previously given, parents may withdraw it at any time."
  },
  {
    "type": "paragraph",
    "text": "This will:"
  },
  {
    "type": "listItem",
    "text": "Stop further data collection",
    "level": 0,
    "ordered": false,
    "numId": "40"
  },
  {
    "type": "listItem",
    "text": "Trigger deletion where applicable",
    "level": 0,
    "ordered": false,
    "numId": "40"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "5. Right to Know (Transparency Right)",
    "id": "5RighttoKnowTransparencyRight"
  },
  {
    "type": "paragraph",
    "text": "Parents have the right to know:"
  },
  {
    "type": "listItem",
    "text": "What data is collected",
    "level": 0,
    "ordered": false,
    "numId": "14"
  },
  {
    "type": "listItem",
    "text": "Why is it collected",
    "level": 0,
    "ordered": false,
    "numId": "14"
  },
  {
    "type": "listItem",
    "text": "How it is used",
    "level": 0,
    "ordered": false,
    "numId": "14"
  },
  {
    "type": "listItem",
    "text": "Whether it is shared with third parties",
    "level": 0,
    "ordered": false,
    "numId": "14"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "Verification Requirement",
    "id": "VerificationRequirement"
  },
  {
    "type": "paragraph",
    "text": "To protect children’s privacy, we may require verification of identity before processing any request."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Data Minimization and Retention",
    "id": "DataMinimizationandRetention"
  },
  {
    "type": "paragraph",
    "text": "We follow strict data minimization principles to protect user privacy, especially for children."
  },
  {
    "type": "listItem",
    "text": "We only collect necessary personal information (like Device type, model, operating system version, App version, performance data, crash logs, diagnostic information, Advertising ID, Usage and Analytics Data) and proportionate to provide and improve our app’s core functionality.",
    "level": 0,
    "ordered": false,
    "numId": "51"
  },
  {
    "type": "listItem",
    "text": "We do not collect excessive, unnecessary, or unrelated data.",
    "level": 0,
    "ordered": false,
    "numId": "51"
  },
  {
    "type": "listItem",
    "text": "We ensure that data collection is limited to specific, explicit, and legitimate purposes.",
    "level": 0,
    "ordered": false,
    "numId": "51"
  },
  {
    "type": "paragraph",
    "text": "For child users:"
  },
  {
    "type": "listItem",
    "text": "We do not require children to provide personal information to access basic features of the app.",
    "level": 0,
    "ordered": false,
    "numId": "3"
  },
  {
    "type": "listItem",
    "text": "We avoid collecting personally identifiable information (PII) unless absolutely required for functionality.",
    "level": 0,
    "ordered": false,
    "numId": "3"
  },
  {
    "type": "listItem",
    "text": "Where possible, we use:",
    "level": 0,
    "ordered": false,
    "numId": "3"
  },
  {
    "type": "listItem",
    "text": "Anonymous data",
    "level": 1,
    "ordered": false,
    "numId": "3"
  },
  {
    "type": "listItem",
    "text": "Aggregated data",
    "level": 1,
    "ordered": false,
    "numId": "3"
  },
  {
    "type": "listItem",
    "text": "Non-identifiable information",
    "level": 1,
    "ordered": false,
    "numId": "3"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "Default Privacy Settings (Privacy by Design)",
    "id": "DefaultPrivacySettingsPrivacybyDesign"
  },
  {
    "type": "listItem",
    "text": "Our app is designed with privacy by default, especially for children.",
    "level": 0,
    "ordered": false,
    "numId": "30"
  },
  {
    "type": "listItem",
    "text": "Features are configured to limit data collection automatically without requiring user action.",
    "level": 0,
    "ordered": false,
    "numId": "30"
  },
  {
    "type": "listItem",
    "text": "Any optional data collection is clearly disclosed and requires user or parental awareness where applicable.",
    "level": 0,
    "ordered": false,
    "numId": "30"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "Data Retention Limitation",
    "id": "DataRetentionLimitation"
  },
  {
    "type": "listItem",
    "text": "We retain personal data only for as long as necessary to fulfill the purposes outlined in this policy.",
    "level": 0,
    "ordered": false,
    "numId": "36"
  },
  {
    "type": "listItem",
    "text": "We delete or anonymize data securely when it is no longer required.",
    "level": 0,
    "ordered": false,
    "numId": "36"
  },
  {
    "type": "listItem",
    "text": "For children’s data, we apply shorter retention periods and stricter safeguards.",
    "level": 0,
    "ordered": false,
    "numId": "36"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "No Sensitive Data Collection",
    "id": "NoSensitiveDataCollection"
  },
  {
    "type": "paragraph",
    "text": "We do not knowingly collect sensitive personal information such as:"
  },
  {
    "type": "listItem",
    "text": "Precise location data",
    "level": 0,
    "ordered": false,
    "numId": "35"
  },
  {
    "type": "listItem",
    "text": "Contact details (phone number, email) from children",
    "level": 0,
    "ordered": false,
    "numId": "35"
  },
  {
    "type": "listItem",
    "text": "Biometric data",
    "level": 0,
    "ordered": false,
    "numId": "35"
  },
  {
    "type": "listItem",
    "text": "Financial information",
    "level": 0,
    "ordered": false,
    "numId": "35"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "Limited Access and Internal Controls",
    "id": "LimitedAccessandInternalControls"
  },
  {
    "type": "listItem",
    "text": "Access to data is restricted to authorized personnel only.",
    "level": 0,
    "ordered": false,
    "numId": "6"
  },
  {
    "type": "listItem",
    "text": "We implement technical and organizational safeguards to prevent unauthorized access, misuse, or disclosure.",
    "level": 0,
    "ordered": false,
    "numId": "6"
  },
  {
    "type": "heading",
    "level": 3,
    "text": "No Profiling or Behavioral Tracking for Children",
    "id": "NoProfilingorBehavioralTrackingforChildren"
  },
  {
    "type": "listItem",
    "text": "We do not profile children or track their behavior for advertising or marketing purposes.",
    "level": 0,
    "ordered": false,
    "numId": "28"
  },
  {
    "type": "listItem",
    "text": "We do not create user profiles based on children’s activity.",
    "level": 0,
    "ordered": false,
    "numId": "28"
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Changes to this privacy policy",
    "id": "Changestothisprivacypolicy"
  },
  {
    "type": "paragraph",
    "text": "We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective, and update the “effective date” at the top of this Privacy Policy."
  },
  {
    "type": "paragraph",
    "text": "You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page."
  },
  {
    "type": "heading",
    "level": 2,
    "text": "Contact us",
    "id": "Contactus"
  },
  {
    "type": "paragraph",
    "text": "If you have any questions or suggestions, please contact us at feedback@rareprob.com. We are also open to your feedback."
  }
];

const linkClass = "text-blue-700 underline underline-offset-2";
const urlOrEmailPattern = /(https?:\/\/[^\s]+|[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})/gi;
const trailingPunctuationPattern = /[.,;:!?)]*$/;

const headingClassName = (level: number) => {
  if (level === 1) return "mt-20 font-bold text-5xl text-gray-800";
  if (level === 2) return "mt-10 text-gray-800 text-3xl font-bold";
  if (level === 3) return "mt-6 text-gray-900 text-xl font-semibold";
  return "mt-5 text-gray-900 text-lg font-semibold";
};

const normalizeSectionText = (text: string) =>
  text.replace(/:$/, "").replace(/[^A-Za-z0-9]+/g, "").toLowerCase();

const toSectionId = (text: string) => text.replace(/:$/, "").replace(/[^A-Za-z0-9]+/g, "");

const overviewItemTexts = (() => {
  const overviewIndex = policyBlocks.findIndex(
    (block) => block.type === "heading" && block.text === "Overview of Privacy Policy"
  );
  const items: string[] = [];

  for (let index = overviewIndex + 1; index > 0 && index < policyBlocks.length; index += 1) {
    const block = policyBlocks[index];
    if (block.type !== "listItem") break;
    items.push(block.text);
  }

  return items;
})();

const overviewItemKeys = new Set(overviewItemTexts.map(normalizeSectionText));

const headingIdByText = policyBlocks.reduce<Record<string, string>>((headings, block) => {
  if (block.type === "heading") {
    headings[normalizeSectionText(block.text)] = block.id;
  }

  return headings;
}, {});

const contentIdByText = policyBlocks.reduce<Record<string, string>>((contentIds, block) => {
  if (block.type === "paragraph") {
    const firstLine = block.text.split("\n")[0];
    const key = normalizeSectionText(firstLine);
    if (overviewItemKeys.has(key)) {
      contentIds[key] = toSectionId(firstLine);
    }
  }

  return contentIds;
}, {});

const getSectionId = (text: string) => {
  const key = normalizeSectionText(text);
  const directMatch = headingIdByText[key] ?? contentIdByText[key];
  if (directMatch) return directMatch;

  const fuzzyHeading = Object.entries(headingIdByText).find(
    ([headingKey]) =>
      headingKey.endsWith(key) ||
      headingKey.includes(`for${key}`) ||
      (key === "privacypolicychanges" && headingKey.includes("changes") && headingKey.includes("privacypolicy"))
  );

  return fuzzyHeading?.[1] ?? toSectionId(text);
};

const getParagraphId = (text: string) => {
  const firstLine = text.split("\n")[0];
  return contentIdByText[normalizeSectionText(firstLine)];
};

const listStyleType = (ordered: boolean, level: number) => {
  if (ordered) return ["decimal", "lower-alpha", "lower-roman"][level % 3];
  return ["disc", "circle", "square"][level % 3];
};

const getListStart = (item: ListBlock | undefined, globalIndex: number) => {
  if (!item?.ordered) return undefined;

  return (
    policyBlocks
      .slice(0, globalIndex)
      .filter(
        (block) =>
          block.type === "listItem" &&
          block.ordered &&
          block.numId === item.numId &&
          block.level === item.level
      ).length + 1
  );
};

const renderLinkedText = (text: string, links: TextLink[] = []) => {
  const [link, ...remainingLinks] = links;

  if (link) {
    const matchIndex = text.indexOf(link.text);

    if (matchIndex !== -1) {
      const before = text.slice(0, matchIndex);
      const after = text.slice(matchIndex + link.text.length);

      return (
        <Fragment>
          {renderLinkedText(before, remainingLinks)}
          <a href={link.href} target="_blank" rel="noopener noreferrer" className={linkClass}>
            {link.text}
          </a>
          {renderLinkedText(after, remainingLinks)}
        </Fragment>
      );
    }
  }

  const parts = text.split(urlOrEmailPattern);

  return parts.map((part, index) => {
    if (!part) return null;

    if (/^https?:\/\//i.test(part)) {
      const trailing = part.match(trailingPunctuationPattern)?.[0] ?? "";
      const href = trailing ? part.slice(0, -trailing.length) : part;

      return (
        <Fragment key={index}>
          <a href={href} target="_blank" rel="noopener noreferrer" className={linkClass}>
            {href}
          </a>
          {trailing}
        </Fragment>
      );
    }

    if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(part)) {
      return (
        <a key={index} href={`mailto:${part}`} className={linkClass}>
          {part}
        </a>
      );
    }

    return <Fragment key={index}>{part}</Fragment>;
  });
};

const isOverviewList = (blocks: PolicyBlock[], startIndex: number) => {
  const previousHeading = [...blocks]
    .slice(0, startIndex)
    .reverse()
    .find((block) => block.type === "heading");

  return previousHeading?.type === "heading" && previousHeading.text === "Overview of Privacy Policy";
};

const renderNestedList = (
  items: ListBlock[],
  overview: boolean,
  globalStartIndex: number,
  startIndex = 0,
  level = items[startIndex]?.level ?? 0
) => {
  const renderedItems: React.ReactNode[] = [];
  const ordered = overview || items[startIndex]?.ordered;
  const start = getListStart(items[startIndex], globalStartIndex + startIndex);
  let index = startIndex;

  while (index < items.length) {
    const item = items[index];
    if (item.level < level) break;

    if (item.level > level) {
      const [, nextIndex] = renderNestedList(items, overview, globalStartIndex, index, item.level);
      index = nextIndex;
      continue;
    }

    index += 1;
    const nestedLists: React.ReactNode[] = [];
    while (index < items.length && items[index].level > level) {
      const [nestedList, nextIndex] = renderNestedList(
        items,
        overview,
        globalStartIndex,
        index,
        items[index].level
      );
      nestedLists.push(nestedList);
      index = nextIndex;
    }

    renderedItems.push(
      <li key={`${item.text}-${index}`}>
        {overview ? (
          <a href={`#${getSectionId(item.text)}`} className="hover:text-blue-700 hover:underline">
            {renderLinkedText(item.text)}
          </a>
        ) : (
          renderLinkedText(item.text)
        )}
        {nestedLists}
      </li>
    );
  }

  const ListTag = ordered ? "ol" : "ul";

  return [
    <ListTag
      key={`list-${startIndex}`}
      start={ordered ? start : undefined}
      className="pl-6 mt-3 space-y-2"
      style={{ listStyleType: listStyleType(ordered, level) }}
    >
      {renderedItems}
    </ListTag>,
    index,
  ] as const;
};

const renderList = (items: ListBlock[], overview: boolean, globalStartIndex: number) =>
  renderNestedList(items, overview, globalStartIndex)[0];

const renderBlocks = () => {
  const rendered: React.ReactNode[] = [];

  for (let index = 0; index < policyBlocks.length; index += 1) {
    const block = policyBlocks[index];

    if (block.type === "listItem") {
      const items: ListBlock[] = [];
      const startIndex = index;

      while (index < policyBlocks.length && policyBlocks[index].type === "listItem") {
        items.push(policyBlocks[index] as ListBlock);
        index += 1;
      }

      index -= 1;
      rendered.push(
        <Fragment key={`list-${startIndex}`}>
          {renderList(items, isOverviewList(policyBlocks, startIndex), startIndex)}
        </Fragment>
      );
      continue;
    }

    if (block.type === "heading") {
      const Tag = `h${Math.min(block.level, 4)}` as keyof JSX.IntrinsicElements;
      rendered.push(
        <Tag key={`${block.id}-${index}`} id={block.id} className={headingClassName(block.level)}>
          {renderLinkedText(block.text)}
        </Tag>
      );
      continue;
    }

    if (block.type === "table") {
      rendered.push(
        <div key={`table-${index}`} className="mt-4 overflow-x-auto">
          <table className="w-full border-collapse text-left text-base md:text-lg">
            <tbody>
              {block.rows.map((row, rowIndex) => (
                <tr key={`${row.join("-")}-${rowIndex}`} className="border-b border-gray-200">
                  {row.map((cell, cellIndex) => (
                    <td
                      key={`${cell}-${cellIndex}`}
                      className={`align-top whitespace-pre-line py-3 pr-4 ${cellIndex === 0 ? "w-1/3 font-semibold text-gray-900" : "text-gray-700"}`}
                    >
                      {renderLinkedText(cell)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
      continue;
    }

    if (block.type === "socialItem") {
      rendered.push(
        <div key={`${block.label}-${index}`} className="mt-6">
          <p className="font-semibold text-gray-900">{renderLinkedText(block.label)}</p>
          <p className="mt-1 whitespace-pre-line">{renderLinkedText(block.text)}</p>
        </div>
      );
      continue;
    }

    rendered.push(
      <p
        key={`paragraph-${index}`}
        id={getParagraphId(block.text)}
        className={`mt-4 whitespace-pre-line ${index === 1 ? "font-medium" : ""} ${block.bold ? "font-bold text-gray-900" : ""}`}
      >
        {renderLinkedText(block.text, block.links)}
      </p>
    );
  }

  return rendered;
};

const PrivacyPolicyScreen = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Rareprob | Privacy Policy</title>
      </Helmet>
      <nav>
        <Header color="bg-[#6B009C]" page="privacy" />
      </nav>
      <main id="start">
        <div className="pt-20 w-5/6 md:w-3/4 px-1 break-words md:px-0 m-auto text-gray-700 text-xl">
          {renderBlocks()}
        </div>
        <div className="pt-10">
          <NewFooter color="bg-[#6a1f9b]/90" />
        </div>
      </main>
    </>
  );
};

export default PrivacyPolicyScreen;
